import api from "../services/api";

// Fetch Driver Partner Support Tickets
export const fetchDriverPartnersSupportTickets = async (
  page = 1,
  size = 10
) => {
  try {
    const response = await api.get("/support-ticket/driver-partners", {
      params: { page, size },
    });

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error: "Unexpected response from server",
    };
  } catch (error) {
    console.error(
      "Error fetching Driver Partner Support Tickets:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.message ||
        "Failed to fetch Driver Partner Support Tickets",
    };
  }
};

// Update Driver Partner Support Ticket
export const updateDriverPartnerSupportTicket = async (
  ticketId,
  payload
) => {
  try {
    const response = await api.put(
      `/support-ticket/ticket/${ticketId}`,
      payload
    );

    if (response.status === 200 && response.data.success) {
      return {
        success: true,
        data: response.data.data,
      };
    }

    return {
      success: false,
      error: "Unexpected response from server",
    };
  } catch (error) {
    console.error(
      "Error updating Driver Partner Support Ticket:",
      error.message || error
    );

    return {
      success: false,
      error:
        error.message ||
        "Failed to update Driver Partner Support Ticket",
    };
  }
};